import {
    ISchemaInput,
    ISIBare,
    ISIConst,
    ISIDefault,
    ISIEnum,
    NestedSchema,
    RootSchema,
    TD,
} from '../union';
import { IsNever, SchemaTypeName } from './core';
import { ISchemaDate } from './date.types';
import { SchemaStringFormat } from './string.types';

export * from './date.types';

/**
 * Property value is a date or array of dates
 */
type DateOmissions = keyof Pick<ISchemaDate, 'format'>;

export function date<EnumVal extends TD<ISchemaDate>>(
    schema: RootSchema<ISchemaInput<ISchemaDate, ISIEnum<ISchemaDate, EnumVal>, DateOmissions>>
): RootSchema<ISchemaDate<EnumVal>>;
export function date<EnumVal extends TD<ISchemaDate>>(
    schema: NestedSchema<ISchemaInput<ISchemaDate, ISIEnum<ISchemaDate, EnumVal>, DateOmissions>>
): NestedSchema<ISchemaDate<EnumVal>>;
export function date<ConstVal extends TD<ISchemaDate>>(
    schema: RootSchema<ISchemaInput<ISchemaDate, ISIConst<ISchemaDate, ConstVal>, DateOmissions>>
): RootSchema<ISchemaDate<ConstVal>>;
export function date<ConstVal extends TD<ISchemaDate>>(
    schema: NestedSchema<ISchemaInput<ISchemaDate, ISIConst<ISchemaDate, ConstVal>, DateOmissions>>
): NestedSchema<ISchemaDate<ConstVal>>;
export function date(
    schema: RootSchema<ISchemaInput<ISchemaDate, ISIBare<ISchemaDate>, DateOmissions>>
): RootSchema<ISchemaDate>;
export function date(
    schema: NestedSchema<ISchemaInput<ISchemaDate, ISIBare<ISchemaDate>, DateOmissions>>
): NestedSchema<ISchemaDate>;
export function date(
    schema: ISchemaInput<ISchemaDate, ISIDefault<ISchemaDate>, DateOmissions>
): ISchemaDate {
    return {
        type: SchemaTypeName.string,
        format: SchemaStringFormat.date_time,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = date({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = date({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
